import { TYPES as DOMAIN_TYPES } from '@empathyco/playboard-core-domain'

// modules/promotion
const PROMOTION_TYPES = {
  PromotionConfigProvider: Symbol.for('PromotionConfigProvider'),
}

// modules/curation-tool/shared
const CURATION_TOOL_SHARED_TYPES = {
  CurationToolAdapter: Symbol.for('CurationToolAdapter'),
  CurationToolFactory: Symbol.for('CurationToolFactory'),
  CurationToolDomainService: Symbol.for('CurationToolDomainService'),
}

// modules/curation-tool/next-queries
const NEXT_QUERIES_TYPES = {
  NextQueriesAdapter: Symbol.for('NextQueriesAdapter'),
  NextQueriesFactory: Symbol.for('NextQueriesFactory'),
  NextQueriesDomainService: Symbol.for('NextQueriesDomainService'),
}

// modules/curation-tool/related-tags
const RELATED_TAGS_TYPES = {
  RelatedTagsAdapter: Symbol.for('RelatedTagsAdapter'),
  RelatedTagsFactory: Symbol.for('RelatedTagsFactory'),
  RelatedTagsDomainService: Symbol.for('RelatedTagsDomainService'),
}

// modules/curation-tool
const CURATION_TOOL_TYPES = {
  ...CURATION_TOOL_SHARED_TYPES,
  ...NEXT_QUERIES_TYPES,
  ...RELATED_TAGS_TYPES,
}

// modules/equalize
const EQUALIZE_TYPES = {
  EqualizeAdapter: Symbol.for('EqualizeAdapter'),
  EqualizeCrudService: Symbol.for('EqualizeCrudService'),
  EqualizeDomainService: Symbol.for('EqualizeDomainService'),
  EqualizeFactory: Symbol.for('EqualizeFactory'),
  EqualizeFieldNamesProvider: Symbol.for('EqualizeFieldNamesProvider'),
}

/**
 * The const to contain all the Keys used for configuring Dependency Injection with InversifyJS.
 * As the Keys are symbols they must be used by reference not by value.
 */
export const TYPES = {
  Messages: Symbol.for('Messages'),

  AuthTokenService: Symbol.for('AuthTokenService'),

  InstanceSearchManagementService: Symbol.for('InstanceSearchManagementService'),

  SessionService: Symbol.for('SessionService'),

  StatsClient: Symbol.for('StatsClient'),
  PlayClient: Symbol.for('PlayClient'),

  Store: Symbol.for('Store'),

  FeaturesConfig: Symbol.for('FeaturesConfig'),

  ObjectIdService: Symbol.for('ObjectIdService'),

  SemanticService: Symbol.for('SemanticService'),
  RelatedPromptsPreviewService: Symbol.for('RelatedPromptsPreviewService'),

  InstancesProvider: Symbol.for('InstancesProvider'),

  /**
   * Key used for Dependency Injection of the provider responsible for returning the
   * application {@link ContextState}.
   */
  TaggingBannerConfigProvider: Symbol.for('TaggingBannerConfigProvider'),

  FeatureConfigProvider: Symbol.for('FeatureConfigProvider'),

  BrowseFacetAdapter: Symbol.for('BrowseFacetAdapter'),
  IndexClientAdapter: Symbol.for('IndexClientAdapter'),
  IndexJobAdapter: Symbol.for('IndexJobAdapter'),
  AuditAdapterProvider: Symbol.for('AuditAdapterProvider'),

  FieldValueAdapter: Symbol.for('FieldValueAdapter'),
  ToolReportingAdapter: Symbol.for('ToolReportingAdapter'),
  FacetsInfoAdapter: Symbol.for('FacetsInfoAdapter'),

  AppConfig: Symbol.for('AppConfig'),

  CrudServiceProvider: Symbol.for('CrudServiceProvider'),
  FacetsInfoCrudServide: Symbol.for('FacetsInfoCrudService'),
  PlayServiceCrudWrapper: Symbol.for('PlayServiceCrudWrapper'),

  QueryRankingDomainService: Symbol.for('QueryRankingDomainService'),
  FacetsDomainService: Symbol.for('FacetsDomainService'),

  BrowseFacetService: Symbol.for('BrowseFacetService'),

  IndexClientService: Symbol.for('IndexClientService'),
  IndexJobService: Symbol.for('IndexJobService'),

  SearchToolingService: Symbol.for('SearchToolingService'),
  ToolReportingService: Symbol.for('ToolReportingService'),
  ToolConfigProvider: Symbol.for('ToolConfigProvider'),
  DomainServiceProvider: Symbol.for('DomainServiceProvider'),
  IndexClientProvider: Symbol.for('IndexClientProvider'),
  AuditObjectTypeConfigProvider: Symbol.for('AuditObjectTypeConfigProvider'),
  KpisConfigProvider: Symbol.for('KpisConfigProvider'),
  RolesProvider: Symbol.for('RolesProvider'),
  FieldValuesService: Symbol.for('FieldValuesService'),

  SearchService: Symbol.for('SearchService'),
  BrowseService: Symbol.for('BrowseService'),

  CalendarConfigProvider: Symbol.for('CalendarConfigProvider'),

  ...CURATION_TOOL_TYPES,
  ...DOMAIN_TYPES,
  ...PROMOTION_TYPES,
  ...EQUALIZE_TYPES,

  XSearchBoxComponent: Symbol.for('XSearchBoxComponent'),

  GetSearchExtraParametersProvider: Symbol.for('GetSearchExtraParametersProvider'),
}
